import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../../base/base.component';
import { Subject, SubjectUserSecurity } from 'app/shared/models/subject';
import { SubjectService } from 'app/shared/services/subject.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { UserSelectionMatrixComponent } from '../../users/user-selection-matrix/user-selection-matrix.component';
import { take } from 'rxjs';

@Component({
  selector: 'app-subject-user-security',
  templateUrl: './subject-user-security.component.html',
  styleUrls: ['./subject-user-security.component.scss'],
})
export class SubjectUserSecurityComponent extends BaseComponent implements OnInit {
  @ViewChild(UserSelectionMatrixComponent) userSelectionMatrix: UserSelectionMatrixComponent;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  hasChanges: boolean;
  title: string;
  subject: Subject;
  userSecurityDtoList: SubjectUserSecurity[];

  constructor(
    public dialogRef: MatDialogRef<SubjectUserSecurityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private subjectService: SubjectService
  ) {
    super();
  }

  ngOnInit(): void {
    this.title = this.data.title || 'Select Users';
    this.subject = this.data.subject;

    this.subjectService
      .getSubjectUserSecurityList(this.subject)
      .pipe(take(1))
      .subscribe((result: SubjectUserSecurity[]) => {
        this.userSecurityDtoList = result;
      });
  }

  onHasChangesChanged(hasChanges: boolean) {
    this.hasChanges = hasChanges;
  }

  save(): void {
    this.userSelectionMatrix.dataGrid.instance.saveEditData().then(() => {
      this.dialogRef.close({
        availableUsers: this.userSelectionMatrix.users,
        selectedUsers: this.userSelectionMatrix.getSelectedUsers(),
        userSecurityDto: this.userSelectionMatrix.userSecurityGridItems.filter((i) => i.isNotUserGroup),
      });
    });
  }
}
